/**
 * Configuración centralizada de variables de entorno
 * Todas las variables de entorno deben ser accedidas desde aquí
 */

// Log para debugging en producción (temporal)
if (typeof window !== 'undefined') {
  console.log('🔧 Config Debug:', {
    NODE_ENV: process.env.NODE_ENV,
    API_URL: process.env.REACT_APP_API_BASE_URL,
    hasVars: !!process.env.REACT_APP_API_BASE_URL
  });
}

const config = {
  // API
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://api.bizzi.com.ar/api',
  },
  
  // Sitio web
  site: {
    url: process.env.REACT_APP_SITE_URL || 'https://bizzi.com.ar',
  },
  
  // Analytics
  analytics: {
    gaId: process.env.REACT_APP_GA_ID,
    gtmId: process.env.REACT_APP_GTM_ID,
    enabled: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  },
  
  // Contacto
  contact: {
    whatsappNumber: process.env.REACT_APP_WHATSAPP_NUMBER || '5491172417131',
    email: process.env.REACT_APP_EMAIL || 'bizzi@bizzi.com.ar',
  },
  
  // Redes sociales
  social: {
    instagram: {
      url: process.env.REACT_APP_INSTAGRAM_URL || 'https://www.instagram.com/bizzi.ok/',
      handle: process.env.REACT_APP_INSTAGRAM_HANDLE || 'bizzi.ok',
    },
  },
  
  // Configuración general
  app: {
    enableLogs: process.env.REACT_APP_ENABLE_LOGS === 'true',
    isDevelopment: process.env.NODE_ENV === 'development',
    isProduction: process.env.NODE_ENV === 'production',
  },
};

// Validación de variables requeridas en producción
if (config.app.isProduction) {
  const requiredVars = [
    { key: 'REACT_APP_API_BASE_URL', value: config.api.baseUrl },
    { key: 'REACT_APP_GA_ID', value: config.analytics.gaId },
    { key: 'REACT_APP_GTM_ID', value: config.analytics.gtmId },
  ];
  
  requiredVars.forEach(({ key, value }) => {
    if (!value) {
      console.error(`⚠️  Variable de entorno faltante: ${key}`);
    }
  });
}

// Helper para logging condicional
export const log = (...args) => {
  if (config.app.enableLogs) {
    console.log('[Bizzi]', ...args);
  }
};

export default config;
